import { ChangeRequest, SellerChangeRequestStatus } from '@/types';

export function isChangeRequestLocked(changeRequest: ChangeRequest) {
    return (
        changeRequest.isClosed ||
        changeRequest.status === SellerChangeRequestStatus.SentToBuyer ||
        changeRequest.status === SellerChangeRequestStatus.Rejected ||
        // changeRequest.status === SellerChangeRequestStatus.CanceledBySeller ||
        changeRequest.status === SellerChangeRequestStatus.AcceptedByBuyer
        
    );
}

export { default } from './ChangeRequestDetails';

